<template>

<div class="amf-modal-dialog">
  <div class="amf-modal-header">
    <div class="amf-modal-title">
      {{title}}
    </div>
  </div>
  <busy-indicator style="margin-top: -1rem" />
  <div class="amf-modal-body">
    <slot></slot>
  </div>
  <div class="amf-modal-footer">
    <hr style="margin: 0;">
    <div v-if="showError" class="mx-3">
      <error-message/>
    </div>
    <div class="amf-button-bar">
      <div class="custom-buttons" >
        <div v-for="b in internalCustomButtons" v-bind:key="b.id" v-if="b.visible">
          <amf-button :class="['modal-button', b._class]" :onClick="() => buttonClick(b)">{{b.text}}</amf-button>
        </div>
      </div>
      <div class="standard-buttons">
        <div v-for="b in internalStandardButtons" v-bind:key="b.id" v-if="b.visible">
            <amf-button :class="['modal-button', b._class]" :onClick="() => buttonClick(b)">{{b.text}}</amf-button>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import changeTracker from "../utils/change-tracker";
import { v } from "framework";

export default {
  provide: function () {
    return {
      closeModal: this.close,
      clearError: this.clearError,
      refreshButtons: this.refreshButtons
    }
  },
  data() {
    return {
      internalStandardButtons: [],
      internalCustomButtons: [],
      error: null,
      title: null,
      amfOptions: { noTracking: true, },
    };
  },
  mounted() {
      if (this.internalStandardButtons.length == 0) {
        this.createAllButtons();
      }
      this.title = this.getInstance().title || "No title";
      this.$emit('loaded');
  },
  computed: {
    showError() {
      let hideFooter = this.getInstance() && this.getInstance().hideFooterError === true;

      return !hideFooter && !!this.error;
    },
  },
  methods: {
    isReadOnly() {
      return this.getInstance().readOnly === true;
    },
    refreshButtons() {
      this.internalStandardButtons = [];
      this.createAllButtons();
    },
    createAllButtons() {
      var buttonsDefinition = "*Save/Cancel"
      if(this.getInstance().buttons)
        buttonsDefinition = this.getInstance().buttons.includes("/") ? "*" + this.getInstance().buttons : this.getInstance().buttons;

      if (this.isReadOnly()) buttonsDefinition = "Close";

      this.addButtons(buttonsDefinition, this.internalStandardButtons);

      if (this.getInstance().buttonsCustom && !this.isReadOnly())
        this.addButtons(this.getInstance().buttonsCustom, this.internalCustomButtons);
    },
    addButtons(buttonsDefinition, buttonsArray) {
        if (!buttonsDefinition) return;

        const extractDefinitionFromName = (buttonName) => {
          const _class = extractButtonClassFromName(buttonName);
          const requiresValidation = buttonName.includes("*");
          const text = buttonName.replace("*", "").replace("!", "").replace("$", "");
          const id = text.toLowerCase();
          return {
            id, text, requiresValidation, _class, visible: true
          }
        }

        const extractButtonClassFromName = (buttonName) => {
          return buttonName.includes("*") ? "btn-success"
            : buttonName.includes("!") ? "btn-danger"
              : buttonName.includes("$") ? "btn-primary"
                : "btn-default";
        }

        if (typeof buttonsDefinition === 'string') {
          var names = buttonsDefinition.split("/");
          names.forEach((name, index) => {
            buttonsArray.push(extractDefinitionFromName(name));
          });
        } else if (Array.isArray(buttonsDefinition)) {
          buttonsDefinition.forEach(def => {
            buttonsArray.push({
              ...extractDefinitionFromName(def.name),
              ...def
            });
          });
        }
    },
    buttonClick(button) {
      if (button.id == "cancel") { this.cancel(); return; }
      if (button.id == "close") { this.close(); return; }
      if(this.internalCustomButtons.find(x => { return x.id == button.id })){
        return this.buttonClickCustom(button);
      } else {
        return this.ok(button);
      }
    },
    async buttonClickCustom(button) {
      let btnName = button.id
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join('');
      btnName = btnName.charAt(0).toLowerCase() + btnName.slice(1);

      this.error = null;
      let instance = this.getInstance();
      const buttonMethod = button.onClick || instance[btnName];
      try {
        var response = await buttonMethod();
        this.$emit("close", response);
      } catch(err) {
        this.error = err;
      }
    },
    getInstance() {
      return this.$slots.default[0].componentInstance;
    },
    skipValidation() {
      return null;
    },
    async ok(button) {
      this.error = null;
      let isModal = true;
      let instance = this.getInstance();
      let okMethod = instance[button.id] || button.onClick;
      let validateMethod = instance.validate || this.skipValidation;

      //if (!instance.$v) return true;
      if (v.invalidComponent(instance)) return;

      // used for custom validation to be handled in the
      // component consuming the amfModal
      var validationResult = validateMethod();

      if (validationResult && validationResult.then) {
        validationResult = await validationResult;
      }

      if (typeof validationResult == "string") {
        this.error = validationResult;
        return;
      }

      if (typeof validationResult == "object" && validationResult != null && validationResult.invalid) {
        this.error = validationResult.message;
        return;
      }

      try {
        var response = await okMethod();
        this.$emit("close", response);
      } catch(err) {
        this.error = err;
      }
    },
    close(response) {
      this.$emit("close", response);
    },
    clearError() {
      this.error = null
    },
    cancel() {
      this.$emit("cancel");
    }
  },

};

</script>

<style lang="scss" scoped>

  .amf-modal-dialog {
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .amf-modal-header {
      margin-bottom: 1rem;
      background-color: darken(lightblue, 20);
      height: 2rem;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      padding-left: 0.25rem;
      padding-right: 0.5rem;
      color: white;
    }

    .amf-modal-title {
      margin-left: 10px;
    }

    .amf-modal-body {
      background-color: white;
      height: 100%;
      padding: 0.5rem;
      position: relative;
    }

    .amf-button-bar {
      padding: 1.1rem 1.4rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .standard-buttons .modal-button {
        margin-left: 1rem;
      }

      .custom-buttons .modal-button {
        margin-right: 1rem;
      }

      .standard-buttons,
      .custom-buttons {
        display: flex;
        flex-direction: row;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfModal.vue